import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'orderDataValue',
  standalone: true,
  pure: false // Hacer el pipe impuro para que se actualice con cambios de idioma
})
export class OrderDataValuePipe implements PipeTransform {

  constructor(private translateService: TranslateService) {}

  transform(value: any): string {
    // Si el valor es un objeto, intentar obtener su propiedad 'name'
    if (typeof value === 'object' && value !== null) {
      return value.name || value.toString();
    }

    // Si es un string, intentar traducirlo
    if (typeof value === 'string') {
      const translationKey = `ORDER_DATA_VALUES.${value}`;
      const translated = this.translateService.instant(translationKey);
      
      // Si la traducción no existe, devolver el valor original
      return translated !== translationKey ? translated : value;
    }

    // Para otros tipos de datos, devolver como string
    return value?.toString() || '';
  }
}